export default __webpack_public_path__ + "static/AMP logo-bc5afa8a2ae2819931c921d88696d5ed.png";